import api from './api/api';

// eslint-disable-next-line import/prefer-default-export
export const find = async (name) => api.get('/activities', { params: { name } }).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});
